import { render, staticRenderFns } from "./systemError.vue?vue&type=template&id=6e883e9e"
import script from "./systemError.vue?vue&type=script&lang=js"
export * from "./systemError.vue?vue&type=script&lang=js"
import style0 from "./systemError.vue?vue&type=style&index=0&id=6e883e9e&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e883e9e')) {
      api.createRecord('6e883e9e', component.options)
    } else {
      api.reload('6e883e9e', component.options)
    }
    module.hot.accept("./systemError.vue?vue&type=template&id=6e883e9e", function () {
      api.rerender('6e883e9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/error-pages/systemError.vue"
export default component.exports